import React from 'react'

import NotificationView from './NotificationView'

export const NotificationContainer = () => {
    return <NotificationView />
}

export default NotificationContainer
